import { logRavenException } from '../../_core/utils/errors';
export const validateDate = (value, upgradeKey) => {
  if (value instanceof Date && !isNaN(value.getTime())) {
    return value;
  }
  logRavenException({
    customMessage: `Invalid date provided for upgrade key ${upgradeKey}`,
    error: Error('validation error in validateDate')
  });
  return null;
};